import * as React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import { artistSiteUrl } from '@webapp/store/artist/selectors';

import styled from 'styled-components';

import SidebarCtrl from '@webapp/controllers/sidebar';
import { Translate } from 'react-localize-redux';
import { hasMerchSubscription } from '../../../store/subscription/selectors';
import { artistProfileSections } from '@webapp/pages/artist-profile';

interface ArtistSiteSidebarCtrlProps {
  className?: string;
  isMobile: boolean;
  siteUrl: string;
  isMerchEnabled: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
  siteUrl: artistSiteUrl(state),
  isMerchEnabled: hasMerchSubscription(state),
});

export const ArtistSiteSidebarCtrl: React.FC<ArtistSiteSidebarCtrlProps> = (
  props
) => {
  return (
    <div className={props.className}>
      <SidebarCtrl
        title={<Translate id="ARTIST.EDITOR.TITLE" />}
        sections={artistProfileSections}
      />
    </div>
  );
};

export default connect(mapStateToProps)(styled(ArtistSiteSidebarCtrl)``);
